module.exports = __webpack_public_path__ + "static/media/ml-object-detection.8dadc923.gif";